import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import classNames from "classnames";

import { expired, dateWithDayOfWeek } from "../../utils/date";
import { TIME } from "../../utils/dateFormats";


const Item = ({ request, onShow }) => (
  <tr>
    <td className="hidden-xs">{request.locationName}</td>
    <td className="hidden-xs">{request.positionName}</td>
    <td>
      <span
        className={classNames({
          "pink-text": expired(request.shift.start_time)
        })}
      >
        {dateWithDayOfWeek(request.shift.start_time, true)} -{" "}
        {moment(request.shift.end_time).format(TIME)}
      </span>
    </td>
    <td className="hidden-xs">
      {request.user ? (
        [request.user.first_name, request.user.last_name].join(", ")
      ) : "EMPLOYEE NOT FOUND"}
    </td>
    <td>{request.sub_full_name}</td>
    <td>
      <a
        href="#"
        className="btn btn-text pointer-hand"
        onClick={() => {
          onShow(request);
        }}
      >
        VIEW
      </a>
    </td>
  </tr>
);

const ListPending = ({ data, onShow }) => (
  <table className="table table-clean table-white shadowDepth1">
    <thead>
      <tr>
        <th className="hidden-xs">Location</th>
        <th className="hidden-xs">Position</th>
        <th>Shift</th>
        <th className="hidden-xs">Requested By</th>
        <th>Sub Name</th>
        <th />
      </tr>
    </thead>
    <tbody>
      {data.map((item, index) => (
        <Item key={index} request={item} onShow={onShow} />
      ))}
    </tbody>
  </table>
);

Item.propTypes = {
  request: PropTypes.object,
  onShow: PropTypes.func
};

ListPending.propTypes = {
  data: PropTypes.array,
  onShow: PropTypes.func
};

export default ListPending;
